import React from "react";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Content from "./components/layout/Content/Content";
import Footer from "./components/layout/Footer/Footer";
import Header from "./components/layout/Header/Header";
import { OfflineProvider } from "./contexts/OfflineContext";
import OfflinePrompt from "./components/widgets/UI/OfflinePrompt";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <OfflineProvider>
          <div className="App">
            <div className="container_custom">
              <Header />
              <Content />
            </div>
            <Footer />
            <OfflinePrompt />
          </div>
        </OfflineProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
